type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const AppointmentHeader: Header[] = [

  {
    key: "patientName",
    label: "Patient",
    style: { width: "350px" },
    sortable: true,
  },
  {
    key: "doctorName",
    label: "Doctor",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "startTime",
    label: "Date & Time",
    style: { width: "130px" },
    sortable: true,
  },
  {
    key: "examTypeDesc",
    label: "Exam Type",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "locations",
    label: "Location",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "appointmentStatusDesc",
    label: "Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "due",
    label: "Due",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "historyStatus",
    label: "Hx Status",
    style: { width: "170px" },
    sortable: true,
  },
  {
    key: "rorStatus",
    label: "ROR Status",
    style: { width: "170px" },
    sortable: true,
  },
  {
    key: "editorStatus",
    label: "Editor Status",
    style: { width: "170px" },
    sortable: true,
  },
    {
    key: "transcriberStatusDesc",
    label: "Transcription Status",
    style: { width: "170px" },
    sortable: true,
  },  
  {
    key: "reportDueDate",
    label: "Report Due Date",
    style: { width: "200px" },
    sortable: true,
  },
    {
    key: "caseId",
    label: "Case ID ",
    style: { width: "160px" },
    sortable: true,
  },
  {
    key: "medicalAssistant",
    label: "Medical Assistant",
    style: { width: "200px" },
    sortable: true,
  },
];

export const ExportAppointmentHeader: Header[] = [
  {
    key: "caseId",
    label: "Case ID ",
    style: { width: "160px" },
    sortable: true,
  },
  {
    key: "patientName",
    label: "Patient",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "doctorName",
    label: "Doctor",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "startTime",
    label: "Date & Time",
    style: { width: "130px" },
    sortable: true,
  },
  {
    key: "examTypeDesc",
    label: "Exam Type",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "locations",
    label: "Location",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "appointmentStatusDesc",
    label: "Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "due",
    label: "Due",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "rorStatus",
    label: "ROR Status",
    style: { width: "170px" },
    sortable: true,
  },
  {
    key: "historyStatus",
    label: "History Status",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "reportDueDate",
    label: "Report Due Date",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "medicalAssistant",
    label: "Medical Assistant",
    style: { width: "200px" },
    sortable: true,
  },
];

export const RUSH_NOTES_HEADER: Header[] = [

  { key: "patientName", label: "Patient Name", style: { width: "25%" } },
  {
    key: "appointmentDateTime",
    label: "Appointment Date & Time",

    style: { width: "15%" },
  },
  {
    key: "noteCategoryDesc",
    label: "Notes Category",

    style: { width: "15%" },
  },
  {
    key: "noteContent",
    label: "Note",

    style: { width: "15%" },
  },
  {
    key: "createdByName",
    label: "Added On | By",

    style: { width: "15%" },
  },
  {
    key: "isAlwaysVisible",
    label: "Expires (In Days)",

    style: { width: "14%" },
  },
  {
    key: "countOfFiles",
    label: "File",
    style: { width: "5%" },
  },


];
